import { render, staticRenderFns } from "./areaInfo.vue?vue&type=template&id=5b73d722&"
import script from "./areaInfo.vue?vue&type=script&lang=js&"
export * from "./areaInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports